import React from 'react';
import {Route, Switch, Redirect} from 'react-router-dom';

import Collection from './components/Videos';
import Categories from './components/Categories';

import ErrorBoundaryRoute from '../../../../containers/ErrorBoundaryRoute';
import Object from "./components/Video";

export default ({match, regions,roles}) => (

	<div>
		<Switch>
			<ErrorBoundaryRoute exact path={`${match.url}`}>
				<Collection regions={regions} roles={roles}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute exact path={`${match.url}/categories`}>
				<Categories regions={regions} roles={roles}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute path={`${match.url}/:id`}>
				<Object regions={regions} roles={roles} baseUrl={match.url}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute>
				<Redirect to={`${match.url}`} />
			</ErrorBoundaryRoute>
		</Switch>
	</div>
);
